module.exports = __webpack_public_path__ + "modules/teas/img/icon-zw-blue.png";